import script from "./TabContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TabContent.vue?vue&type=script&setup=true&lang=js"

import "./TabContent.vue?vue&type=style&index=0&id=72dad4a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72dad4a2"]])

export default __exports__